import { useEffect, useState } from "react";

const useCountdown = (timer: number = 300) => {
  const [countdownTime, setCountdownTime] = useState(timer);

  useEffect(() => {
    // * countdown in 5mins
    let timer = setInterval(() => {
      setCountdownTime((time) => {
        if (time === 0) {
          clearInterval(timer);
          return 0;
        } else return time - 1;
      });
    }, 1000);
  }, []);

  const countdown = `${Math.floor(countdownTime / 60)
    .toString()
    .padStart(2, "0")}:${(countdownTime % 60).toString().padStart(2, "0")}`;

  return [countdown];
};

export default useCountdown;
